import React from 'react';

import {
    Checkbox,
    Stack,
    TableCell,
    TableRow,
    Typography,
} from '@mui/material';

import type RefundProductDto from '../../../models/RefundProductDto';

interface ProductRowProps {
    item: RefundProductDto;
    selected: boolean;
    onSelectChange: (value: boolean, refundProduct: RefundProductDto) => void;
}

const SearchProductRow: React.FC<ProductRowProps> = ({
    item,
    selected,
    onSelectChange,
}) => {
    return (
        <TableRow>
            <TableCell padding="none">
                <Stack flexDirection="row" alignItems="center" gap={2}>
                    <img
                        height={50}
                        width={50}
                        style={{ objectFit: 'contain' }}
                        src={
                            item.image !== '' ? item.image : 'assets/empty.png'
                        }
                    />

                    <Stack gap={0.5}>
                        <Typography variant="body1">
                            {item.description}
                        </Typography>

                        <Typography variant="caption" color="GrayText">
                            {item.itemNo}
                        </Typography>
                    </Stack>
                </Stack>
            </TableCell>

            <TableCell padding="none">
                <Typography variant="body1">{item.documentNo}</Typography>
            </TableCell>

            <TableCell align="right" padding="none">
                <Checkbox
                    checked={selected}
                    onChange={(event) =>
                        onSelectChange(event.target.checked, item)
                    }
                />
            </TableCell>
        </TableRow>
    );
};

export default SearchProductRow;
